import axios from "axios";
import Swal from 'sweetalert2';

const state = {
  benefitList: [], 
  benefitArr: [],
  benefitArray: [],
  benefitID: '',
  selectedBenefit: null,
  selectedLedger: null,
  isEditing: false
};
  
const mutations = {
  initializeStore(state){
    state.benefitList = [];
    state.benefitArr = [];
    state.benefitArray = [];
    state.benefitID = "";
    state.selectedBenefit = null;
    state.selectedLedger = null;
    state.isEditing = false;
  },
  SET_SELECTED_BENEFIT(state, benefit) {
    state.selectedBenefit = benefit;
    state.isEditing = true;
  },
  LIST_BENEFITS(state, benefits) {
    state.benefitList = benefits;
  },
  BENEFITS_ARRAY(state, benefits){
    state.benefitArray = benefits;
  },
  SET_SELECTED_LEDGER(state, ledger) {
    state.selectedLedger = ledger;
  },
  SET_STATE(state, payload) {
    for (const key in payload) {
        if (payload.hasOwnProperty(key) && key in state) {
            state[key] = payload[key];
        }
    }
  },
  SET_SEARCH_FILTERS(state, search_filter){
    for(const [key, value] of Object.entries(search_filter)){
      
    }
  },
  RESET_SEARCH_FILTERS(state){
   
  }
};
  
const actions = {
  updateState({ commit }, newState) {
    commit('SET_STATE', newState);
  },
  
  async createEmployeeBenefit({ commit,state }, formData) {
    return axios.post('api/v1/create-employee-benefit/', formData)
    .then((response)=>{
      return response;
    })
    .catch((error)=>{
      console.log(error.message);
      throw error;
    })
  },

  fetchEmployeeBenefits({ commit,state }, formData) {
    state.benefitArr = [];
    axios.post(`api/v1/get-employee-benefits/`,formData)
    .then((response)=>{
      for(let i=0; i< response.data.length; i++){
        state.benefitArr.push((response.data[i].benefit_type + " Benefit - Effective: " + response.data[i].date));
      }
      commit('LIST_BENEFITS', response.data);
    })
    .catch((error)=>{
      console.log(error.message);
    })
    
  },
  fetchEmployeeBenefit({ commit,state }, formData) {
    axios.post(`api/v1/get-employee-benefits/`,formData)
    .then((response)=>{
      state.selectedBenefit = response.data;
      const selectedLedger = response.data.posting_account.ledger_code + " - " + response.data.posting_account.ledger_name;
      commit('SET_SELECTED_BENEFIT',response.data);
      commit('SET_SELECTED_LEDGER', selectedLedger);
    })
    .catch((error)=>{
      console.log(error.message);
    })
    
  },
  handleSelectedBenefit({ commit, state }, option){
    const selectedBenefit = state.benefitList.find(benefit => (benefit.benefit_type + " Benefit - Effective: " + benefit.date) === option);
    if (selectedBenefit) {
        state.benefitID = selectedBenefit.employee_benefit_id;
        selectedBenefit.benefit_employee_id = null;
        state.benefitArray = [...state.benefitArray, selectedBenefit];
    }
    commit('BENEFITS_ARRAY', state.benefitArray);
      
  },

  async updateEmployeeBenefit({ commit,state }, formData) {
    return axios.put(`api/v1/update-employee-benefit/`,formData)
    .then((response)=>{
      return response;
    })
    .catch((error)=>{
      console.log(error.message);
      throw error;
    })  
  },

  deleteEmployeeBenefit({ commit,state }, formData) {
    Swal.fire({
      title: "Are you sure?",
      text: `Do you wish to delete Employee Benefit?`,
      type: 'warning',
      showCloseButton: true,
      showCancelButton: true,
      confirmButtonText: 'Yes Delete Employee Benefit!',
      cancelButtonText: 'Cancel!',
      customClass: {
          confirmButton: 'swal2-confirm-custom',
          cancelButton: 'swal2-cancel-custom',
      },
      showLoaderOnConfirm: true,
    }).then((result) => {
      if (result.value) {
        axios.post(`api/v1/delete-employee-benefit/`,formData)
        .then((response)=>{
          if(response.status == 200){
              Swal.fire("Poof! Employee Benefit removed succesfully!", {
                icon: "success",
              }); 
          }else{
            Swal.fire({
              title: "Error Deleting Employee Benefit",
              icon: "warning",
            });
          }                   
        })
        .catch((error)=>{
          console.log(error.message);
          Swal.fire({
            title: error.message,
            icon: "warning",
          });
        })
      }else{
        Swal.fire(`Employee Benefit has not been deleted!`);
      }
    })
  },
  removeBenefit({commit, state}, index){
    state.benefitArray.splice(index, 1); 
    commit('BENEFITS_ARRAY', state.benefitArray);
  },
};
  
const getters = {
  // users: (state) => state.users,
  // currentUser: (state) => state.currentUser,
};
  
export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
  
  